// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconSmtCduTab_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2H2V12H9V14H0V0H14V7H12V2Z" class="svg-bg"/>
  <path d="M11 3H3V5H11V3ZM11 6H3V8H11V6ZM13.998 16C14.8216 16 15.4889 15.8763 16 15.6289V14.1885C15.4889 14.488 14.9258 14.6377 14.3105 14.6377 13.666 14.6377 13.1533 14.4375 12.7725 14.0371 12.3916 13.6335 12.2012 13.0931 12.2012 12.416 12.2012 11.7096 12.403 11.1497 12.8066 10.7363 13.2103 10.3229 13.7409 10.1162 14.3984 10.1162 14.9974 10.1162 15.5312 10.2562 16 10.5361V9.01758C15.5312 8.84505 14.9551 8.75879 14.2715 8.75879 13.168 8.75879 12.2695 9.1071 11.5762 9.80371 10.8861 10.5003 10.541 11.4085 10.541 12.5283 10.541 13.5798 10.8486 14.4212 11.4639 15.0527 12.0791 15.6842 12.9238 16 13.998 16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconSmtCduTab is a generated icon component.
 */
let IconSmtCduTab = IconSmtCduTab_1 = class IconSmtCduTab extends IconBaseElement {
    render() {
        return html `${IconSmtCduTab_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconSmtCduTab.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconSmtCduTab = IconSmtCduTab_1 = __decorate([
    customElement('zui-icon-smt-cdu-tab')
], IconSmtCduTab);
export { IconSmtCduTab };
